if (!customElements.get('treatment-country-select')) {
  customElements.define('treatment-country-select', class TreatmentCountrySelect extends CustomSelect {

    init ()
    {
      super.init();

      this.addEventListener('change', e => {
        window.app.treatmentCountry.set(this.selectElement.value);
      });

      onBroadcast('treatment_country', data => {
        const country = window.app && window.app.treatmentCountry
          ? window.app.treatmentCountry.getSelection().country
          : null;
        const option = country
          ? this.selectElement.querySelector(`option[value="${country}"]`)
          : null;

        // A stored country that is no longer offered (settings list changed)
        // has no matching option — don't let it kill this listener.
        if (!option) {
          return;
        }

        this.optionIndex = option.index;
        this.value = country;
        this.selectElement.value = this.value;
        this.update();

        if (this.value.toUpperCase() !== data.code.toUpperCase()) {
          this.value = data.code.toUpperCase();
          this.dispatchEvent(new Event('change'));
        }
      });
    }
  });
}